<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body agent-level-body">
        <div class="title-body">
          <h3>DANH SÁCH CẤP ĐẠI LÝ</h3>
          <div class="title-btn">
            <el-button
              type="primary"
              @click="fn_addSlide()"
              icon="el-icon-circle-plus-outline"
              >thêm mới cấp đại lý</el-button
            >
          </div>
        </div>

        <div class="main-body">
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              style="width: 100%"
            >
              <el-table-column fixed prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                prop="ten"
                fixed
                label="Quản lý cấp"
                min-width="120"
                align="center"
              ></el-table-column>
              <el-table-column label="Chiết khấu (%)" min-width="120">
                <el-table-column
                  v-for="item in mData.listSanPham"
                  :key="item.san_pham_id"
                  :label="item.ten"
                  min-width="120"
                  align="center"
                >
                  <template #default="scope">
                    <div>{{ getValueSanPham(item.id, scope.$index) }}</div>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                prop="mo_ta"
                fixed="right"
                label="Mô tả"
                min-width="200"
                align="center"
              >
                <template #default="scope">
                  <el-tooltip
                    effect="dark"
                    placement="top"
                    :content="customText(scope.row.mo_ta)"
                  >
                    <div slot="content">{{ customText(scope.row.mo_ta) }}</div>
                    <span>{{ customText(scope.row.mo_ta) }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="Hoạt động"
                fixed="right"
                min-width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.hieu_luc"
                    @change="updateEnable(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column> -->
              <el-table-column
                label="Chiết khấu khách"
                fixed="right"
                min-width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.chiet_khau_khach"
                    @change="updateStatusChietKhauKhach(scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="Công khai"
                fixed="right"
                min-width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.cong_khai"
                    @change="updateStatusCongKhai(scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="Thao tác"
                align="center"
                width="110px"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.row)"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.row)"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import MethodService from "../../../../service/MethodService";
import LanguageService from "../../../../service/LanguageService";
import DataForm from "../../../../dataForm/dataFormCapDaiLy";
import mushroom from "viettoc-api";

export default {
  data() {
    return {
      loading: false,
      aLang: LanguageService.lang,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
        listSanPham: [],
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    // data
    async getData() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachCapDaiLy",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
            },
          })
          .catch((err) => {});
      }
      try {
        const response = await mushroom.agt_cap.listAsync(dataFilter, {
          cacheAge: 1,
        });
        let resData = await this.fn_changeData(response.result);
        this.mData.tableRules.data = resData;
        console.log("this.mData.tableRules.data", this.mData.tableRules.data);
        this.mData.tableRules.total = response.meta.total;
        this.mData.tableRules.page = response.meta.offset / response.meta.limit + 1;
        setTimeout(() => {
          this.loading = false;
        }, 1000)
      } catch (e) {
        console.error("Có lỗi: %o", e);
        MethodService.showError(e.code);
      }
    },
    // custom data
    async fn_changeData(data) {
      const listSanPhamId = [];
      data.forEach((item) => {
        if (item.chiet_khau && item.chiet_khau.length > 0) {
          item.chiet_khau.forEach((e) => {
            if (e.san_pham_id) {
              if (!listSanPhamId.find((x) => x === e.san_pham_id))
                listSanPhamId.push(e.san_pham_id);
            }
          });
        }
      });
      try {
        const response = await mushroom.prd_san_pham.getAllAsync({
          filters: [
            `id:in:${listSanPhamId.join()}`,
            "dai_ly_ban=true",
            "hieu_luc=true",
          ],
          limit: 100,
        });
        this.mData.listSanPham = response.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
      data
        .filter((cap) => cap.chiet_khau && cap.chiet_khau.length > 0)
        .forEach((cap) => {
          cap.chiet_khau.forEach((sp) => {
            sp.san_pham_name = this.mData.listSanPham.filter(
              (item) => item.id === sp.san_pham_id
            ).ten;
          });
        });
      return data;
    },
    // lấy giá trị của sản phẩm tương ứng
    getValueSanPham(id, index) {
      if (this.mData.tableRules.data[index].chiet_khau) {
        let count = -1;
        this.mData.tableRules.data[index].chiet_khau.forEach(
          (item, indexItem) => {
            if (item.san_pham_id == id) {
              count = indexItem;
            }
          }
        );
        if (count != -1) {
          return this.mData.tableRules.data[index].chiet_khau[count].gia_tri;
        }

        return "";
      } else {
        return "";
      }
    },
    // thêm cấp
    fn_addSlide() {
      this.$router.push({
        name: "TaoCapDaiLy",
      });
    },

    // chuyển trang
    fn_handle(type, row) {
      if (type == "detail") {
        this.$router.push({
          name: "CapDaiLyChiTiet",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatCapDaiLy",
          params: { id: row.id },
        });
      }
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      console.log("this.mData.tableRules: ", this.mData.tableRules);
      this.getData();
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },

    // cập nhật trường enable
    async updateEnable(row) {
      const agt_cap_object = {
        id: row.id,
        hieu_luc: row.hieu_luc,
      };
      try {
        const response = await mushroom.agt_cap.partialUpdateAsync(
          agt_cap_object
        );
        if (response.result == agt_cap_object.id) {
          window.toastr.success("Cập nhật trạng thái Cấp đại lý thành công");
        } else console.log("Dữ liệu không thay đổi");
      } catch (e) {
        console.log(e);
        this.loading = false;
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },
    // cập nhật trường cong_khai
    async updateStatusCongKhai(row) {
      const agt_cap_object = {
        id: row.id,
        cong_khai: row.cong_khai
      }
      try {
        const response = await mushroom.agt_cap.partialUpdateAsync(
          agt_cap_object
        );
        if (response.result == agt_cap_object.id) {
          window.toastr.success("Cập nhật trạng thái Cấp đại lý thành công");
        } else console.log("Dữ liệu không thay đổi");
      } catch (e) {
        this.loading = false;
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
        this.resetDataIfError(row, 'cong_khai')
      }
    },

    // cập nhật trường chiet_khau_khach
    async updateStatusChietKhauKhach(row) {
      const agt_cap_object = {
        id: row.id,
        chiet_khau_khach: row.chiet_khau_khach
      }
      try {
        const response = await mushroom.agt_cap.partialUpdateAsync(
          agt_cap_object
        );
        if (response.result == agt_cap_object.id) {
          window.toastr.success("Cập nhật trạng thái chiết khẩu khách thành công");
        } else console.log("Dữ liệu không thay đổi");
      } catch (e) {
        this.loading = false;
        console.log(row);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
        this.resetDataIfError(row, 'chiet_khau_khach')
      }
    },

    resetDataIfError(rowData, filed) {
      this.mData.tableRules.data.forEach(item => {
        if (item.id === rowData.id) item[filed] = !rowData[filed]
      })
      console.log('this.mData.tableRules.data', this.mData.tableRules.data)
    },

    customText(text) {
      if (text) {
        return text.replace(new RegExp("[\r\n]", "gm"), ", ");
      }
    },
  },

  async created() {
    this.loading = true
    await this.fn_hashUrl();
    await this.getData();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cell {
  .el-checkbox__input.is-disabled.is-checked {
    .el-checkbox__inner {
      background-color: #409EFF;
      border-color: #409EFF;
      &::after {
        border-color: #fff;
      }
    }
  }
}
::v-deep .agent-level-body {
  min-height: calc(100vh - 80px);
}
</style>
